import type { TypeOptions } from "react-toastify";
import { Bounce, toast } from "react-toastify";
import i18n from "../../../i18n";

export interface ToastNotifyStyle{
  fontSize?: string 
}

export const notify = (msg: string, type: TypeOptions, errorCode: string, isCustomMessage?: boolean) => {
  const mapMsgAPI: Record<string, string> = {
    "0002": i18n.t("toast.userNotFound"),
    "0001": i18n.t("toast.accessDenied"),
    "0004": i18n.t("toast.emailInUse"),
    "0005": i18n.t("toast.emailNeedsVerification"),
    "0006": i18n.t("toast.userDisabled"),
    "0007": i18n.t("toast.tokenNotFound"),
    "0008": i18n.t("toast.tokenExpired"),
    "9999": i18n.t("toast.incorrectCredentials"),
  };
  const msgErro = mapMsgAPI[errorCode]
    ? mapMsgAPI[errorCode]
    : (isCustomMessage 
      ? msg  
      : i18n.t("toast.unexpectedError")
    );

  toast(type === "error" ? msgErro : msg, {
    position: "bottom-right",
    autoClose: 4000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: 0,
    theme: "colored",
    transition: Bounce,
    type,
    style: {
      borderRadius: "12px",
    },
  });
};


export const notifyNode = (msg: React.ReactNode, type: TypeOptions) => {
  
  toast(msg, {
    position: "bottom-right",
    autoClose: 4000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: 0,
    theme: "colored",
    transition: Bounce,
    type,
    style: {
      borderRadius: "12px",
    },
  });
};

export const notifyWithTitle = (msgTitle: string, msg: string, type: TypeOptions, toastStyle?: ToastNotifyStyle) => {
  
  const style = {
    marginTop: '8px',
    fontSize: '11px',
    ...(toastStyle && toastStyle)
  }

  const msgNode = <>
      <div>{msgTitle}</div>
      <div style={{...style}}>{msg}</div>
    </>

  toast(msgNode, {
    position: "bottom-right",
    autoClose: 4000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: 0,
    theme: "colored",
    transition: Bounce,
    type,
    style: {
      borderRadius: "12px",
    },
  });
};